/* =====================================================================
   WAVEFORM — shared engagement features (HANDOFF §4c/§4d)
   Wishlist, quick view and recently-viewed, ported from the prototype
   onto real product data: every product card carries a data-pc JSON
   payload (rendered by snippets/product-card.liquid), so the modules
   never scrape the DOM or hardcode products.

   window.WaveformWish          = { has, add, remove, toggle, all, count,
                                    hydrate, onChange }
   window.WaveformQuickView     = { open(data), close(), enhance() }
   window.WaveformRecentlyViewed= { record, all, render, clear }

   Wishlist persists to localStorage for guests — for logged-in
   customers the same API can be backed by a customer metafield via an
   app (the API shape is the contract, per the HANDOFF).
   ===================================================================== */
(function () {
  'use strict';

  function pcData(card) {
    try { return JSON.parse(card.dataset.pc || 'null'); } catch (e) { return null; }
  }
  function icon(name, cls) {
    return '<svg' + (cls ? ' class="' + cls + '"' : '') + ' aria-hidden="true"><use href="#icon-' + name + '"/></svg>';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function stars(n) {
    var h = '';
    var filled = Math.round(n || 5);
    for (var i = 1; i <= 5; i++) if (i <= filled) h += icon('star');
    return h;
  }

  /* ================= WISHLIST ================= */
  var Wish = (function () {
    var LS = 'waveform-wishlist';
    function load() {
      try { var r = localStorage.getItem(LS); if (r) return JSON.parse(r); } catch (e) {}
      return [];
    }
    var items = load();
    var subs = [];
    function persist() { try { localStorage.setItem(LS, JSON.stringify(items)); } catch (e) {} }
    function fire() { persist(); hydrate(); subs.forEach(function (fn) { try { fn(items.slice()); } catch (e) {} }); }
    function has(id) { return items.some(function (x) { return String(x.id) === String(id); }); }
    function add(it) { if (it && it.id && !has(it.id)) { items.unshift(it); fire(); } }
    function remove(id) { items = items.filter(function (x) { return String(x.id) !== String(id); }); fire(); }
    function toggle(it) { if (!it || !it.id) return false; if (has(it.id)) remove(it.id); else add(it); return has(it.id); }

    function itemOf(h) {
      if (h.dataset.wishPc) { try { return JSON.parse(h.dataset.wishPc); } catch (e) {} }
      var card = h.closest('.product-card');
      if (card) return pcData(card);
      return null;
    }
    function idOf(h) {
      var it = itemOf(h);
      return it ? it.id : null;
    }
    function hydrate() {
      document.querySelectorAll('.pc-fav, .bb-wishlist, .qv-wish').forEach(function (h) {
        var id = idOf(h);
        if (!id) return;
        var on = has(id);
        h.classList.toggle('on', on);
        h.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var h = e.target.closest('.pc-fav, .bb-wishlist, .qv-wish');
      if (!h) return;
      e.preventDefault();
      e.stopPropagation();
      var it = itemOf(h);
      if (!it || !it.id) return;
      toggle(it);
      if (window.WaveformBump) window.WaveformBump(h);
    });
    return { has: has, add: add, remove: remove, toggle: toggle, all: function () { return items.slice(); }, count: function () { return items.length; }, hydrate: hydrate, onChange: function (fn) { if (typeof fn === 'function') subs.push(fn); } };
  })();

  /* ================= QUICK VIEW ================= */
  var QuickView = (function () {
    var scrim, modal, lastFocused = null;
    var strings = window.WaveformStrings || {};

    function ensureShell() {
      if (modal) return;
      scrim = document.createElement('div'); scrim.className = 'qv-scrim';
      modal = document.createElement('div'); modal.className = 'qv-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'qvTitle');
      modal.setAttribute('aria-hidden', 'true');
      document.body.appendChild(scrim);
      document.body.appendChild(modal);
      scrim.addEventListener('click', close);
    }

    function open(d) {
      if (!d) return;
      ensureShell();
      lastFocused = document.activeElement;
      var badges = '';
      if (!d.available) badges += '<span class="badge soldout">' + esc(strings.sold_out || 'Sold out') + '</span>';
      else if (d.on_sale) badges += '<span class="badge sale">' + esc(strings.sale || 'SALE') + '</span>';
      if (d.best) badges += '<span class="badge best">' + esc(strings.best_seller || '★ Best Seller') + '</span>';
      var media = d.image
        ? '<img src="' + esc(d.image) + '" alt="' + esc(d.title) + '" loading="lazy">'
        : '<div class="ph-media"><span class="ph-label">' + esc(d.title) + '</span></div>';
      var action;
      if (!d.available) {
        action = '<button class="btn btn-secondary btn-lg btn-block qv-add" disabled>' + esc(strings.sold_out || 'Sold out') + '</button>';
      } else if (d.has_options || !d.variant_id) {
        action = '<a class="btn btn-primary btn-lg btn-block qv-add" href="' + esc(d.url) + '">' + icon('cart') + ' ' + esc(strings.choose_options || 'Choose options') + '</a>';
      } else {
        action = '<button class="btn btn-primary btn-lg btn-block qv-add" data-quick-add="' + esc(d.variant_id) + '">' + icon('cart') + ' ' + esc(strings.add_to_cart || 'Add to cart') + '</button>';
      }
      modal.innerHTML =
        '<div class="qv-card">'
        + '<button class="qv-x" data-qv-close aria-label="' + esc(strings.close || 'Close') + '">' + icon('x') + '</button>'
        + '<div class="qv-media">' + (badges ? '<div class="pc-badges">' + badges + '</div>' : '') + media + '</div>'
        + '<div class="qv-info">'
        +   (d.type ? '<span class="qv-cat">' + icon(d.icon || 'spark') + ' ' + esc(d.type) + '</span>' : '')
        +   '<h2 id="qvTitle" class="qv-title">' + esc(d.title) + '</h2>'
        +   (d.sub ? '<p class="qv-sub">' + esc(d.sub) + '</p>' : '')
        +   (d.rating ? '<div class="qv-rating"><span class="stars">' + stars(d.rating) + '</span> ' + esc(d.rating) + (d.rating_count ? ' · ' + esc(d.rating_count) + ' ' + esc(strings.reviews || 'reviews') : '') + '</div>' : '')
        +   '<div class="qv-price"><span class="qv-now">' + esc(d.price_f) + '</span>'
        +     (d.was_f ? '<span class="qv-was">' + esc(d.was_f) + '</span>' : '')
        +     (d.save_pct ? '<span class="qv-save">−' + esc(d.save_pct) + '%</span>' : '')
        +   '</div>'
        +   (d.desc ? '<p class="qv-blurb">' + esc(d.desc) + '</p>' : '')
        +   '<div class="qv-actions">'
        +     action
        +     '<button class="btn btn-secondary qv-wish" aria-label="' + esc(strings.save_wishlist || 'Save to wishlist') + '" aria-pressed="false" data-wish-pc="' + esc(JSON.stringify(d)) + '">' + icon('heart') + '</button>'
        +   '</div>'
        +   '<a class="qv-full" href="' + esc(d.url) + '">' + esc(strings.view_full || 'View full details') + ' ' + icon('arrow') + '</a>'
        + '</div>'
        + '</div>';
      scrim.classList.add('open');
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      Wish.hydrate();
      var x = modal.querySelector('[data-qv-close]');
      if (x) setTimeout(function () { x.focus(); }, 30);
    }

    function close() {
      if (!modal) return;
      scrim.classList.remove('open');
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
      lastFocused = null;
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab' || !modal.classList.contains('open')) return;
      var f = Array.prototype.filter.call(
        modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function enhance(root) {
      (root || document).querySelectorAll('.product-card[data-pc] .pc-media').forEach(function (media) {
        if (media.querySelector('.pc-qv')) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pc-qv';
        btn.setAttribute('aria-label', strings.quick_view || 'Quick view');
        btn.innerHTML = icon('eye');
        media.appendChild(btn);
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-qv-close]')) { e.preventDefault(); close(); return; }
      /* an add inside quick view closes it so the cart drawer shows cleanly */
      if (e.target.closest('.qv-add[data-quick-add]')) { close(); return; }
      var t = e.target.closest('.pc-qv');
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      var card = t.closest('.product-card');
      if (card) open(pcData(card));
    });

    var pending = false;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          if (!pending) {
            pending = true;
            requestAnimationFrame(function () { pending = false; enhance(); Wish.hydrate(); });
          }
          return;
        }
      }
    });
    function init() { enhance(); mo.observe(document.body, { childList: true, subtree: true }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    return { open: open, close: close, enhance: enhance };
  })();

  /* ================= RECENTLY VIEWED ================= */
  var Recent = (function () {
    var LS = 'waveform-recently-viewed';
    var MAX = 8, SHOW = 4;
    var strings = window.WaveformStrings || {};
    function load() {
      try { var r = localStorage.getItem(LS); if (r) return JSON.parse(r); } catch (e) {}
      return [];
    }
    var items = load();
    function persist() { try { localStorage.setItem(LS, JSON.stringify(items)); } catch (e) {} }
    function record(it) {
      if (!it || !it.id) return;
      items = items.filter(function (x) { return String(x.id) !== String(it.id); });
      items.unshift(it);
      if (items.length > MAX) items = items.slice(0, MAX);
      persist();
    }

    function cardHTML(p) {
      var badges = '';
      if (p.on_sale) badges = '<div class="pc-badges"><span class="badge sale">' + esc(strings.sale || 'SALE') + '</span></div>';
      var quick = '';
      if (!p.available) quick = '<button class="btn btn-secondary btn-block btn-sm" disabled>' + esc(strings.sold_out || 'Sold out') + '</button>';
      else if (p.has_options || !p.variant_id) quick = '<a class="btn btn-primary btn-block btn-sm" href="' + esc(p.url) + '">' + icon('cart') + ' ' + esc(strings.choose_options || 'Choose options') + '</a>';
      else quick = '<button class="btn btn-primary btn-block btn-sm" data-quick-add="' + esc(p.variant_id) + '">' + icon('cart') + ' ' + esc(strings.add_to_cart || 'Add to cart') + '</button>';
      var media = p.image
        ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">'
        : '<div class="ph-media"><span class="ph-label">' + esc(p.title) + '</span></div>';
      return '<article class="product-card" data-pc="' + esc(JSON.stringify(p)) + '">'
        + '<div class="pc-media">' + badges
        +   '<a href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + media + '</a>'
        +   '<div class="pc-quick">' + quick + '</div>'
        + '</div>'
        + '<div class="pc-body">'
        +   '<div class="pc-head"><span class="pc-cat">' + icon(p.icon || 'spark') + ' ' + esc(p.type || p.sub) + '</span>'
        +     '<button class="pc-fav" type="button" aria-label="' + esc(strings.save_wishlist || 'Save to wishlist') + '" aria-pressed="false">' + icon('heart') + '</button></div>'
        +   '<span class="pc-sub">' + esc(p.sub) + '</span>'
        +   '<a class="pc-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>'
        +   (p.rating ? '<span class="pc-rating"><span class="stars">' + stars(p.rating) + '</span> ' + esc(p.rating) + ' · ' + esc(p.rating_count || 0) + ' ' + esc(strings.reviews || 'reviews') + '</span>' : '')
        +   '<div class="pc-price"><span class="now">' + esc(p.price_f) + '</span>' + (p.was_f ? '<span class="was">' + esc(p.was_f) + '</span>' : '') + '</div>'
        + '</div></article>';
    }

    function render() {
      var hosts = document.querySelectorAll('[data-recently-viewed]');
      if (!hosts.length) return;
      var curEl = document.querySelector('[data-rv-current]');
      var currentHandle = curEl ? curEl.getAttribute('data-rv-current') : null;
      var list = items.filter(function (p) { return p.handle !== currentHandle; }).slice(0, SHOW);
      hosts.forEach(function (host) {
        var section = host.closest('[data-rv-section]');
        if (!list.length) {
          if (section) section.hidden = true;
          host.innerHTML = '';
          return;
        }
        host.innerHTML = list.map(cardHTML).join('');
        if (section) section.hidden = false;
      });
      QuickView.enhance();
      Wish.hydrate();
    }

    function init() {
      var src = document.querySelector('[data-rv-product]');
      if (src) {
        try { record(JSON.parse(src.getAttribute('data-rv-product'))); } catch (e) {}
      }
      render();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    return { record: record, all: function () { return items.slice(); }, render: render, clear: function () { items = []; persist(); render(); } };
  })();

  window.WaveformWish = Wish;
  window.WaveformQuickView = QuickView;
  window.WaveformRecentlyViewed = Recent;
})();
